<template>
    <div class="relation">
        <div class="kgr-postfix  kgr-postfix--center kgr-postfix--gutters kgr-row relation-row animated fadeIn">
            <div class="kgr-postfix__fixed">
                <kgr-profile-image
                    :src="memberAvatarUrl"
                    :alt="member.fullName()"
                    size="S"
                />
            </div>

            <div class="kgr-postfix__fluid">
                <a
                    :href="memberUrl"
                    class="kgr-link kgr-link--unobtrusive"
                >
                    {{ member.fullName() }}
                </a>
            </div>
            <div
                v-if="!hideMiddleButton"
                class="kgr-postfix__fixed"
            >
                <kgr-button
                    v-if="showAddLegalRepresentative"
                    type="grey"
                    :value="$t('Vertretungsberechtigung für %{fullName} hinzufügen', { fullName })"
                    @click="add"
                />
            </div>
            <div
                v-if="isDeletable"
                class="kgr-postfix__fixed"
            >
                <kgr-button
                    type="red"
                    :value="removeButtonLabel"
                    :pending="pendingRemove"
                    @click="$emit('remove')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import KgrButton from '../common/form/button/KgrButton';
import { MemberRelationMember } from '../../js/dto/MemberRelation';
import ProfileImage from '../common/ProfileImage';
import UrlMixin from './UrlMixin';

export default {
    components: {
        'kgr-profile-image': ProfileImage,
        KgrButton,
    },
    mixins: [UrlMixin],
    props: {
        member: {
            type: MemberRelationMember,
            required: true,
        },
        legalMember: {
            type: Object,
            required: true,
        },
        pendingRemove: {
            type: Boolean,
            required: true,
        },
        legalRepresentatives: {
            type: Array,
            required: false,
            default: null,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
        removeButtonLabel: {
            type: String,
            required: true,
        },
        hideMiddleButton: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            addLegalRepresentativeClicked: false,
        };
    },
    computed: {
        memberUrl() {
            return this.urlForMember(this.member.id);
        },
        memberAvatarUrl() {
            return this.avatarUrl(this.member.id, this.member.hasAvatar, this.member.gender, this.member.avatarFileName);
        },
        showAddLegalRepresentative() {
            if (this.addLegalRepresentativeClicked) {
                return false;
            }

            if (this.legalRepresentatives === null) {
                return false;
            }

            return this.legalRepresentatives.findIndex((legalRepresentative) => legalRepresentative.id === this.member.id) === -1;
        },
        fullName() {
            if (!this.legalMember) {
                return '';
            }
            let fullName = this.legalMember.lastName;

            if (this.legalMember.firstName) {
                fullName = `${this.legalMember.firstName} ${fullName}`;
            }

            return fullName;
        },
    },
    methods: {
        add() {
            this.addLegalRepresentativeClicked = true;
            this.$emit('addLegalRepresentative');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.relation-row {
    margin-top: 4px;
    padding-left: 4px;
}

.relation-link {
    float: left;
    line-height: 3;
}

.buttons {
    float: right;
    margin-top: 8px;
    margin-right: 4px;

    & > a {
        margin-right: 5px;
    }
}

.avatar {
    border-width: medium;
    margin-top: 0;
    margin-bottom: 0;
    width: 40px;
    height: 40px;
}

.link {
    cursor: pointer;
}
</style>
